import {
  Box,
  Checkbox,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import moment from "moment";
import { LuInbox } from "react-icons/lu";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { vesselTableHeadingViewOnly } from "../../../constants";
import * as calculatorActions from "../../../containers/User/Calculator/actions";
import * as dashboardActions from "../../../containers/User/Dashboard/actions";
import {
  getCurrentUserId,
  getOrganizationId,
  toastSuccess,
} from "../../../utils";

function UserCopyFleet(props) {
  const {
    loader = false,
    setLoader = () => { },
    getInitalQueryAndFleetData = () => { },
    onClickAddFleet = () => { },
    getAllFleets = () => { },
  } = props;
  const dispatch = useDispatch();
  const { userOrganizaton = [] } = useSelector((state) => state.dashboard);
  const [selectedUser, setSelectedUser] = useState("");
  const [userFleets, setUserFleets] = useState([]);
  const [selectedFleets, setSelectedFleets] = useState([]);

  useEffect(() => {
    if (!userOrganizaton.length) {
      dispatch(
        dashboardActions.usersForOrg({ organizationId: getOrganizationId() })
      )
        .then(() => {
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    }
  }, []);

  const onChangeUser = async (e) => {
    const { name = "", value = "" } = e.target;
    setSelectedFleets([]);
    setSelectedUser(value);
    setLoader(true);
    const req = { userId: value, isFromCopyVessel: true }
    await calculatorActions.userFleets(req).then((res) => {
      setUserFleets((res.data && Array.isArray(res.data.list) && res.data.list) || []
      );
    });
    setLoader(false);
  };

  const onChangeInputCheck = (fleetId) => {
    let updatedSelectedFleets = [...selectedFleets];
    const isFindIndex = updatedSelectedFleets.findIndex(
      (item) => item === fleetId
    );
    if (isFindIndex > -1) {
      updatedSelectedFleets.splice(isFindIndex, 1);
    } else {
      updatedSelectedFleets.push(fleetId);
    }
    updatedSelectedFleets = [...new Set(updatedSelectedFleets)];
    setSelectedFleets(updatedSelectedFleets);
  };

  const onSelectAllFleet = (isAllSelected) => {
    let ids = userFleets.map((item) => item._id);
    if (isAllSelected) ids = [];
    setSelectedFleets(ids);
  };

  const onUserFleetDataCopy = () => {
    if (selectedFleets.length === 0 || !selectedFleets) return;
    const sendObj = {
      id: selectedUser,
      selectedFleet: selectedFleets.map((item) => ({ id: item })),
    };
    setLoader(true);

    calculatorActions
      .userFleetDataCopy(sendObj)
      .then((res) => {
        setLoader(false);
        toastSuccess("Fleets copied successfully");
        getAllFleets()
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  let newUserOrganizaton = useMemo(() => {
    return Array.isArray(userOrganizaton)
      ? userOrganizaton.filter((item) => item._id !== getCurrentUserId())
      : [];
  }, [userOrganizaton]);

  const isAllSelected = selectedFleets.length > 0 && selectedFleets.length === userFleets.length;
  return (
    <div className="w-full flex flex-col user-copy-container">
      <div className="w-full flex items-center justify-center gap-2 mb-3 mt-1">
        <div className="w-[200px]">
          <select
            value={selectedUser}
            onChange={onChangeUser}
            style={{ height: 26, minHeight: 26, paddingTop: 0, paddingBottom: 0 }}
            className="w-full text-[11px] border border-[#cbd5e1] rounded-none outline-none bg-white text-[#1e293b] font-medium leading-tight px-2"
          >
            <option value="" disabled>
              Select User
            </option>
            {newUserOrganizaton.map((item, index) => {
              return (
                <option key={index} value={item._id}>
                  {item.firstName} {item?.lastName}
                </option>
              );
            })}
          </select>
        </div>
        <button
          type="button"
          onClick={onUserFleetDataCopy}
          className="h-[26px] px-4 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#0c2f50] rounded-none border border-[#313C4C] cursor-pointer transition-colors"
        >
          COPY
        </button>
      </div>

      <div className="w-full mt-1">
        <TableContainer
          component={Paper}
          style={{
            minHeight: "auto",
            overflow: loader ? "hidden" : "auto",
          }}
        >
          <Table className="fleet-list-table user-fleet-table [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap">
            <TableHead>
              <TableRow>
                {vesselTableHeadingViewOnly.map((item) => {
                  if (item.id === "checkbox") {
                    return (
                      <TableCell key={item._id || item.id} style={{ width: 40, textAlign: "center" }}>
                        <Checkbox
                          size="small"
                          checked={isAllSelected}
                          onChange={() => onSelectAllFleet(isAllSelected)}
                        />
                      </TableCell>
                    );
                  }
                  return (
                    <TableCell key={item._id || item.id}>
                      {item.title}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    align="center"
                    className="!bg-white"
                  >
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="200px"
                    >
                      <CircularProgress size={20} />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : Array.isArray(userFleets) && userFleets.length ? (
                userFleets.map((vessel) => {
                  const {
                    _id,
                    vesselName = "",
                    dateOpen = "",
                    port = "",
                    gbb = 0,
                    hireGbb = 0,
                    hirePerDay = 0,
                    remark = "",
                    vessel: fleetVesselData,
                  } = vessel || {};
                  const { vesselDwt = 0 } = JSON.parse(fleetVesselData) || "";
                  const isChecked = selectedFleets.includes(_id);

                  return (
                    <TableRow key={_id}>
                      <TableCell style={{ width: 40, textAlign: "center" }}>
                        <Checkbox
                          size="small"
                          checked={isChecked}
                          onChange={() => onChangeInputCheck(_id)}
                        />
                      </TableCell>
                      <TableCell>{vesselName}</TableCell>
                      <TableCell>{vesselDwt}</TableCell>
                      <TableCell>{port}</TableCell>
                      <TableCell>
                        {dateOpen ? moment(dateOpen).format("DD/MMM/yyyy HH:mm") : ""}
                      </TableCell>
                      <TableCell>{gbb}</TableCell>
                      <TableCell>{hirePerDay}</TableCell>
                      <TableCell>{hireGbb}</TableCell>
                      <TableCell>{remark}</TableCell>
                    </TableRow>
                  );
                })
              ) : null}
            </TableBody>
          </Table>
          {!loader && !(Array.isArray(userFleets) && userFleets.length) && (
            <div className="sticky left-0 w-full flex flex-col items-center justify-center gap-1.5 py-10 px-4 bg-white text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-100 border border-slate-200 text-slate-400">
                <LuInbox size={24} />
              </div>
              <p className="m-0 text-[12px] font-medium text-slate-700">No Fleet Found.</p>
              <p className="m-0 text-[11px] text-slate-500">Select a user to see the vessels in their fleet.</p>
            </div>
          )}
        </TableContainer>
      </div>
    </div>
  );
}

export default UserCopyFleet;
